<template>
  <div
    class="crafty-image__wrapper"
    data-pendo-ds="image"
  >
    <div
      class="crafty-image"
      :class="{
        [boxShadowClass]: boxShadow !== 'none',
        [borderRadiusClass]: borderRadius !== 'none',
      }"
      :style="{
        aspectRatio,
        width,
      }"
    >
      <slot name="overlay" />
      <img
        v-show="loading && preloadSrc"
        :alt="alt"
        class="crafty-image__img"
        :class="{
          [borderRadiusClass]: borderRadius !== 'none',
        }"
        :loading="lazy ? 'lazy' : 'eager'"
        :src="preloadSrc"
        :style="{
          objectPosition,
          objectFit,
          backgroundColor
        }"
      >
      <img
        v-show="!loading || !preloadSrc"
        :alt="alt"
        class="crafty-image__img"
        :class="{
          [borderRadiusClass]: borderRadius !== 'none',
        }"
        :loading="lazy ? 'lazy' : 'eager'"
        :src="computedSrc"
        :style="{
          objectPosition,
          objectFit,
          backgroundColor
        }"
        @error="useFallback = true"
        @load="onLoad"
      >
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseImage',
  props: {
    src: {
      type: String,
      default: null,
    },
    preloadSrc: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      required: true,
    },
    objectPosition: {
      type: String,
      default: 'center',
      validator: (value) => {
        return ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top'].includes(value)
      },
    },
    objectFit: {
      type: String,
      default: 'contain',
      validator: (value) => {
        return ['fill', 'contain', 'cover', 'none', 'scale-down'].includes(value)
      },
    },
    borderRadius: {
      type: String,
      default: 'none',
      validator: (value) => {
        return ['none', 'small', 'large', 'circle'].includes(value)
      },
    },
    aspectRatio: {
      type: String,
      default: '1/1',
    },
    width: {
      type: String,
      default: '100%',
    },
    boxShadow: {
      type: String,
      default: 'none',
      validator: (value) => {
        return ['none', 'small', 'medium', 'large'].includes(value)
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
    fallbackSrc: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      useFallback: false,
    }
  },
  computed: {
    boxShadowClass() {
      return `cr-ds-${this.boxShadow}`
    },
    borderRadiusClass() {
      return `cr-br-${this.borderRadius}`
    },
    computedSrc() {
      if (this.useFallback || !this.src)
        return this.fallbackSrc

      return this.src
    },
  },
  created() {
    const img = new Image()
    img.src = this.src
  },
  methods: {
    onLoad() {
      this.loading = false
    },
  },
}
</script>


<style scoped lang="scss">
.crafty-image {
  overflow: hidden;
  position: relative;
  &__img {
    width: 100%;
    height: 100%;
  }
}

</style>
